import type { Reducer } from 'redux';
import {
  REMOVE_REQUEST,
  REQUEST_ERROR,
  REQUEST_PENDING,
  REQUEST_SUCCESS,
  type RequestAction,
  type RequestErrorAction,
  type RequestPendingAction,
  type RequestSuccessAction,
  STATUS,
} from '../actions';

export interface RequestEntry {
  id: string;
  status: string;
  method?: string;
  url?: string;
  body?: any;
  json?: any;
  text?: any;
  responseStatus?: number;
  options?: any;
  promise?: Promise<any>;
}

export type RequestState = Record<string, RequestEntry>;

const initialState: RequestState = {};

type RequestRecordAction =
  | RequestPendingAction
  | RequestSuccessAction
  | RequestErrorAction;

function getActionState(
  action: RequestRecordAction,
  state: RequestState,
  status: string,
): RequestState {
  const { method, url, options, id, body, promise } = action;
  const responseStatus =
    action.type === REQUEST_PENDING ? undefined : action.responseStatus;
  const json = action.type === REQUEST_PENDING ? undefined : action.json;
  const text = action.type === REQUEST_PENDING ? undefined : action.text;
  return {
    ...state,
    [id]: {
      id: String(id),
      status,
      method,
      url,
      body,
      json,
      text,
      responseStatus,
      options,
      promise,
    },
  };
}

const reducer: Reducer<RequestState, RequestAction> = (state = initialState, action) => {
  let newState: RequestState;

  switch (action.type) {
    case REQUEST_PENDING:
      return getActionState(action, state, STATUS.pending);
    case REQUEST_SUCCESS:
      if (state[action.id]) {
        return getActionState(action, state, STATUS.success);
      }
      return state;
    case REQUEST_ERROR:
      if (state[action.id]) {
        return getActionState(action, state, STATUS.error);
      }
      return state;
    case REMOVE_REQUEST:
      newState = { ...state };
      delete newState[action.id];
      return newState;
    default:
      return state;
  }
};

export default reducer;
